// Recovered compiled webpack factory 23656. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { F: () => s });
  let n = (t, e) => (i) => e(t(i)),
    s = (...t) => t.reduce(n);
}
